import { hardenNavigator } from '@wix/client-security'

export const removeServiceWorker = hardenNavigator
